/**
 * Centralized query keys for Provider Connections feature
 * All files in this feature should import and use these constants
 * instead of hardcoding query key strings.
 */

export const PROVIDER_CONNECTIONS_LIST_QUERY_KEY = 'provider-connections-list';
export const CONNECTION_QUERY_KEY = 'provider-connection';
export const CONNECTION_NOTES_QUERY_KEY = 'provider-connection-notes';
export const CONNECTION_STATUS_HISTORY_QUERY_KEY = 'provider-connection-status-history';
export const CONNECTION_CHANGE_HISTORY_QUERY_KEY = 'provider-connection-change-history';
export const CONNECTION_EVENT_HISTORY_QUERY_KEY = 'provider-connection-event-history';
